// frontend/src/services/api.js
import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');

      try {
        const response = await axios.post(`${config.API_BASE_URL}/accounts/token/refresh/`, {
          refresh: refreshToken,
        });
        const { access } = response.data;
        localStorage.setItem('access_token', access);
        originalRequest.headers.Authorization = `Bearer ${access}`;
        return api(originalRequest);
      } catch (err) {
        console.error('Refresh token error:', err);
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Product Services
export const productService = {
  getAll: (params) => api.get('/products/products/', { params }),
  getBySlug: (slug) => api.get(`/products/products/${slug}/`),
  getFeatured: () => api.get('/products/products/featured/'),
  getNewest: () => api.get('/products/products/newest/'),
  getCategories: () => api.get('/products/categories/'),
};

// Category Services
export const categoryService = {
  getAll: () => api.get('/products/categories/'),
  getBySlug: (slug) => api.get(`/products/categories/${slug}/`),
  getSubCategories: (slug) => api.get(`/products/categories/${slug}/subcategories/`),
};

// Auth Services
export const authService = {
  login: (credentials) => api.post('/accounts/token/', credentials),
  register: (userData) => api.post('/accounts/register/', userData),
  getProfile: () => api.get('/accounts/profile/'),
  updateProfile: (data) => api.patch('/accounts/profile/', data),
  refreshToken: (refresh) => api.post('/accounts/token/refresh/', { refresh }),
};

// Installation Services
export const installationService = {
  createRequest: (data) => api.post('/installations/requests/', data),
  getMyRequests: () => api.get('/installations/my-requests/'),
  getRequestDetail: (id) => api.get(`/installations/requests/${id}/`),
};

// CMS Services
export const cmsService = {
  getMenus: (position) => api.get(`/cms/menus/?position=${position}`),
  getSettings: () => api.get('/cms/settings/get_settings/'),
  getPageBySlug: (slug) => api.get(`/cms/pages/${slug}/`),
  getFooter: () => api.get('/cms/footer/get_footer/'),
  getBanners: (position) => api.get(`/cms/banners/?position=${position}`),
};

// ✅ اضافه کردن این خط مهم - برای رفع خطای productStore
export { api };